export default "__VITE_ASSET__s8u9RmEF__"